import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: 'hidden',
    position: 'absolute',
    width: '100%',
    top: '0px',
    right: '0px',
    height: '100%',
    backgroundImage: 'linear-gradient(#3C419A, #27284C)',
  },
  root: {
    position: 'absolute',
    top: 'calc(50% - 290px)',
    left: 'calc(50% - 303px)',
    width: '572px',
    height: '585px',
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '5px',
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '30px',
    paddingBottom: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '28px',
    color: '#2C2D3E',
  },
  text: {
    display: 'flex',
    justifyContent: 'start',
    textAlign: 'left',
    maxWidth: '405px',
    paddingBottom: '40px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    color: '#2C2D3E',
  },
  label: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '350px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    transform: 'translateX(45px)',
    paddingTop: '8px',
    paddingBottom: '8px',
    margin: '0px',
  },
  divider: {
    width: '350px',
    transform: 'translateX(25px)',
  },
  formControl: {
    width: '345px',
    height: '50px',
    transform: 'translateX(45px)',
    marginBottom: '30px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '15px',
  },
  selectEmpty: {
    marginTop: '15px',
  },
  button: {
    position: 'relative',
    left: '290px',
    width: '100px',
    height: '30px',
    borderColor: '#3C419A',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: '#3C419A',
    marginBottom: '20px',
    paddingTop: '6px',
  },
  margin: {
    margin: theme.spacing(1),
  },
  submit: {
    position: 'absolute',
    left: 'calc(35% - 32px)',
    top: 'calc(50% + 213px)',
    width: '230px',
    height: '45px',
    borderRadius: '3px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
  },
}));
